// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Navigation from './components/Navigation';
import PhotoUpload from './screens/PhotoUpload';
import UserProfile from './screens/UserProfile';
import Results from './screens/Results';

function App() {
  return (
      <AuthProvider>
        <ThemeProvider>
          <Router>
            <Navigation />
            <Routes>
              <Route path="/" element={<PhotoUpload />} />
              <Route path="/profile" element={<UserProfile />} />
              <Route path="/results" element={<Results />} />
              {/* Add other routes as needed */}
            </Routes>
          </Router>
        </ThemeProvider>
      </AuthProvider>
  );
}

export default App;
